const SyriaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112505)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="#D80027"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="black"
      />
      <path
        d="M11.95 15.2168L13.0291 18.538H16.5215L13.6962 20.591L14.7754 23.9124L11.95 21.8597L9.12459 23.9124L10.2038 20.591L7.37842 18.538H10.8708L11.95 15.2168Z"
        fill="#6DA544"
      />
      <path
        d="M28.0501 15.2168L29.1292 18.538H32.6217L29.7963 20.591L30.8755 23.9124L28.0501 21.8597L25.2247 23.9124L26.3039 20.591L23.4785 18.538H26.9709L28.0501 15.2168Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112505">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SyriaSvg;
